import { render, staticRenderFns } from "./pluginPropVal.vue?vue&type=template&id=ac1ed616&"
import script from "./pluginPropVal.vue?vue&type=script&lang=ts&"
export * from "./pluginPropVal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports